/* eslint-disable no-tabs */
/* eslint-disable no-const-assign */
import React from 'react';
import { getWonferfulPic } from '../../../../../services/api';
import styles from './index.css';
import Title from '../../../components/title';
import EnqueryAlert from '../../../components/enqueryAlert';
import PropTypes from 'prop-types';

class WonderfulPic extends React.PureComponent {
    static propTypes = {
        curCity: PropTypes.object,
    };

    constructor(...argv) {
        super(...argv);
        this.state = {
            wonderfulPicData: [],
            handleData: [],
            index: 0,
            isEnqueryAlertShow: false,
            carSeriesData: {},
        };
    }

    async handleDataFun(data) {
        const arr = [];
        const arr_tab = [];
        const arr_content = [];

        arr.push(arr_tab);
        arr.push(arr_content);

        for (let key in data) {
            if (key !== 'status') {
                arr_tab.push(key);
                arr_content.push(data[key]);
            }
        }

        return arr;
    }

    async componentDidMount() {
        const wonderfulPicData = await getWonferfulPic();
        const handleData = await this.handleDataFun(wonderfulPicData);

        this.setState({
            wonderfulPicData,
            handleData,
        });
    }

    block(tabIndex) {
        const index = this.state ? this.state.index : 0;

        return { display: index === tabIndex ? 'block' : 'none' };
    }

    showCarList() {
        return this.state.handleData[1].map((item, index) => {
            return (
                <li key={index} style={this.block(index)}>
                    <div className={styles.pic_s}>
                        <div className={styles.pic_s_b}>
                            <div className={styles.pic_div}>
                                <a href={item[0].openUrl} target="_blank">
                                    <img ifengsrc={item[0].imgUrl} src={item[0].imgUrl} />
                                </a>
                                <div className={styles.imgt}>{item[0].title}</div>
                                <div className={styles.imgm} />
                            </div>
                            <div className={styles.div_tip}>
                                <div className={styles.tipWord}>
                                    <div className={styles.carname}>{item[0].title}</div>
                                    <div className={styles.price}>指导价格： {item[0].guidePrice}</div>
                                </div>
                                <div className={styles.tipButton}>
                                    <div className={styles.shipai}>
                                        <a className={styles.shipai_a} target="_blank" href={item[0].openUrl}>
                                            实拍
                                        </a>
                                    </div>
                                    <div
                                        className={styles.xunjia}
                                        onClick={this.xunjiaHandlerClick.bind(this, item[0])}>
                                        询价
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.pic_s_b}>
                            <div className={styles.pic_div}>
                                <a href={item[1].openUrl} target="_blank">
                                    <img ifengsrc={item[1].imgUrl} src={item[1].imgUrl} />
                                </a>
                                <div className={styles.imgt}>{item[1].title}</div>
                                <div className={styles.imgm} />
                            </div>
                            <div className={styles.div_tip}>
                                <div className={styles.tipWord}>
                                    <div className={styles.carname}>{item[1].title}</div>
                                    <div className={styles.price}>指导价格： {item[1].guidePrice}</div>
                                </div>
                                <div className={styles.tipButton}>
                                    <div className={styles.shipai}>
                                        <a className={styles.shipai_a} target="_blank" href={item[1].openUrl}>
                                            实拍
                                        </a>
                                    </div>
                                    <div
                                        className={styles.xunjia}
                                        onClick={this.xunjiaHandlerClick.bind(this, item[1])}>
                                        询价
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.pic_m}>
                        <div>
                            <a className={styles.pic_aaa} href={item[2].openUrl} target="_blank">
                                <img ifengsrc={item[2].imgUrl} src={item[2].imgUrl} />
                            </a>
                            <div className={styles.imgt}>{item[2].title}</div>
                            <div className={styles.imgm} />
                        </div>
                        <div className={styles.div_tip1}>
                            <div className={styles.tipWord}>
                                <div className={styles.carname}>{item[2].title}</div>
                                <div className={styles.price}>指导价格： {item[2].guidePrice}</div>
                            </div>
                            <div className={styles.tipButton}>
                                <div className={styles.shipai}>
                                    <a className={styles.shipai_a} target="_blank" href={item[2].openUrl}>
                                        实拍
                                    </a>
                                </div>
                                <div className={styles.xunjia} onClick={this.xunjiaHandlerClick.bind(this, item[2])}>
                                    询价
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.pic_s}>
                        <div className={styles.pic_s_b}>
                            <div className={styles.pic_div}>
                                <a href={item[3].openUrl} target="_blank">
                                    <img ifengsrc={item[3].imgUrl} src={item[3].imgUrl} />
                                </a>
                                <div className={styles.imgt}>{item[3].title}</div>
                                <div className={styles.imgm} />
                            </div>
                            <div className={styles.div_tip}>
                                <div className={styles.tipWord}>
                                    <div className={styles.carname}>{item[3].title}</div>
                                    <div className={styles.price}>指导价格： {item[3].guidePrice}</div>
                                </div>
                                <div className={styles.tipButton}>
                                    <div className={styles.shipai}>
                                        <a className={styles.shipai_a} target="_blank" href={item[3].openUrl}>
                                            实拍
                                        </a>
                                    </div>
                                    <div
                                        className={styles.xunjia}
                                        onClick={this.xunjiaHandlerClick.bind(this, item[3])}>
                                        询价
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.pic_s_b}>
                            <div className={styles.pic_div}>
                                <a href={item[4].openUrl} target="_blank">
                                    <img ifengsrc={item[4].imgUrl} src={item[4].imgUrl} />
                                </a>
                                <div className={styles.imgt}>{item[4].title}</div>
                                <div className={styles.imgm} />
                            </div>
                            <div className={styles.div_tip}>
                                <div className={styles.tipWord}>
                                    <div className={styles.carname}>{item[4].title}</div>
                                    <div className={styles.price}>指导价格： {item[4].guidePrice}</div>
                                </div>
                                <div className={styles.tipButton}>
                                    <div className={styles.shipai}>
                                        <a className={styles.shipai_a} target="_blank" href={item[4].openUrl}>
                                            实拍
                                        </a>
                                    </div>
                                    <div
                                        className={styles.xunjia}
                                        onClick={this.xunjiaHandlerClick.bind(this, item[4])}>
                                        询价
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            );
        });
    }

    handleChangeIndex(index, event) {
        let liArr = [];

        liArr = document.getElementById('showCarContent').getElementsByTagName('li');

        for (let i = 0; i < liArr.length; i++) {
            liArr[i].style.display = 'none';
        }

        liArr[index].style.display = 'block';
    }

    showTabsView() {
        return this.state.handleData[0].map((item, index) => {
            switch (item) {
                case 'newCarInfo':
                    item = '新车';
                    break;

                case 'newSerialInfo':
                    item = '热门';
                    break;

                case 'suvCarInfo':
                    item = 'SUV';
                    break;
                case 'car_5_8':
                    item = '5-8万';
                    break;
                case 'car_8_12':
                    item = '8-12万';
                    break;
                case 'car_12_15':
                    item = '12-15万';
                    break;
                case 'car_15_18':
                    item = '15-18万';
                    break;
                case 'car_18_25':
                    item = '18-25万';
                    break;
                case 'car_25_40':
                    item = '25-40万';
                    break;
                case 'car_40_60':
                    item = '40-60万';
                    break;
                case 'car_60':
                    item = '60万以上';
                    break;
            }

            return (
                <span key={index} onMouseOver={this.handleChangeIndex.bind(this, index)}>
                    {item}
                </span>
            );
        });
    }

    xunjiaHandlerClick = item => {
        const carSeriesData = {
            brand: item.brandId,
            serial: item.serialId,
        };

        this.setState({
            carSeriesData,
            isEnqueryAlertShow: true,
        });
    };
    getChildData = res => {
        this.setState({
            isEnqueryAlertShow: res,
        });
    };
    /**
     * 渲染组件
     */
    render() {
        const { curCity } = this.props;
        const { isEnqueryAlertShow, carSeriesData } = this.state;

        return (
            <div>
                {this.state.wonderfulPicData.newSerialInfo && this.state.wonderfulPicData.newSerialInfo.length > 0 ? (
                    <div>
                        <div className={styles.jmxtdiv} id="auto_p_9">
                            <Title content="精美图集" />
                            <div className={styles.col_tit}>
                                <div className={styles.col_tit_l}>
                                    <a id="auto_p_9t_1" href="https://data.auto.ifeng.com/photo/" target="_blank">
                                        图片
                                    </a>
                                    <a id="auto_p_9t_2" href="https://data.auto.ifeng.com/price/" target="_blank">
                                        报价库
                                    </a>
                                    <a id="auto_p_9t_3" href="https://car.auto.ifeng.com/top/" target="_blank">
                                        汽车排榜
                                    </a>
                                </div>
                                {/* <div className={styles.col_tit_r}>
                                    <a id="auto_p_9t_4" href="https://data.auto.ifeng.com/photo/" target="_blank">
                                        更多&gt;&gt;
                                    </a>
                                </div> */}
                            </div>
                            <div className={styles.pictures}>
                                <div className={styles.pic_tag}>{this.showTabsView()}</div>
                                <ul id="showCarContent" className={styles.pic_box}>
                                    {this.showCarList()}
                                </ul>
                            </div>
                        </div>
                        {isEnqueryAlertShow ? (
                            <EnqueryAlert news={this} carSeriesData={carSeriesData} curCity={curCity} />
                        ) : (
                            ''
                        )}
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default WonderfulPic;
